import React, { useEffect } from "react";
import { Severity } from "@eveworld/types";
import { useNotification, useSmartObject } from "@eveworld/contexts";

import { JSX } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import RecruitingImage from "/src/images/RecruitmentPoster2.png";
import RecruitingImage2 from "/src/images/ReapersWeWantYou.png";
import InitVars from "../InitVars";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const Recruit = React.memo(
  () //   {
  : JSX.Element => {
    const { loading } = useSmartObject();
    const { notify, handleClose } = useNotification();

    var joinMessage = "CLICK HERE TO JOIN OUR DISCORD CHANNEL";
    if (InitVars.calledFromEF == true) {
      joinMessage =
        "HEAD TO https://discord.gg/frontier-reapers TO JOIN US NOW";
    }

    //const { worldContract } = useWorldContract();

    useEffect(() => {
      if (loading) {
        notify({ type: Severity.Info, message: "Loading..." });
      } else {
        handleClose();
      }
    }, [loading]);

    return (
      <>
        <div className="title">
          <p>HEAD TO https://discord.gg/frontier-reapers TO JOIN US NOW</p>
        </div>
        <Carousel autoPlay infiniteLoop showThumbs={false} interval={7500}>
          <div>
            <img src={RecruitingImage} className="recruitingcarouselimg" />
          </div>
          <div>
            <img src={RecruitingImage2} className="recruitingcarouselimg" />
          </div>
        </Carousel>
      </>
    );
  }
);

export default React.memo(Recruit);
